import React, { useEffect, useState } from 'react';
import { MenuIcon, XIcon } from 'lucide-react';
import { Button } from '../ui/Button';
export function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navigation = [{
    name: 'How It Works',
    href: '/how-it-works'
  }, {
    name: 'Who We Serve',
    href: '/who-we-serve'
  }, {
    name: 'Case Studies',
    href: '/case-studies'
  }, {
    name: 'About',
    href: '/about'
  }];
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 bg-deep-blue ${isScrolled ? 'shadow-lg' : ''}`} data-id="element-54">
      <nav className="container-custom" data-id="element-55">
        <div className="flex items-center justify-between h-20" data-id="element-56">
          {/* Logo */}
          <a href="/" className="flex items-center group flex-shrink-0" data-id="element-57">
            <img src="https://cdn.magicpatterns.com/uploads/swEJUHNizYeuA4zr1U4nTc/all_white_medium_logo.png" alt="HIRE - High Impact Recruiting Engine" className="h-10 md:h-12 w-auto transition-transform group-hover:scale-105" data-id="element-58" />
          </a>

          {/* Desktop Navigation - Hide earlier to prevent wrapping */}
          <div className="hidden xl:flex items-center space-x-8" data-id="element-59">
            {navigation.map(item => <a key={item.name} href={item.href} className="text-white/80 hover:text-white font-medium transition-colors whitespace-nowrap" data-id="element-60">
                {item.name}
              </a>)}
          </div>

          {/* CTA Button - Hide earlier to prevent wrapping */}
          <div className="hidden xl:block flex-shrink-0" data-id="element-61">
            <Button href="/book-call" showArrow data-id="element-62">
              Schedule a Strategy Call
            </Button>
          </div>

          {/* Mobile Menu Button - Show earlier */}
          <button className="xl:hidden p-2 text-white" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} data-id="element-63">
            {isMobileMenuOpen ? <XIcon className="h-6 w-6" data-id="element-64" /> : <MenuIcon className="h-6 w-6" data-id="element-65" />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && <div className="xl:hidden py-4 border-t border-white/10" data-id="element-66">
            <div className="flex flex-col space-y-4" data-id="element-67">
              {navigation.map(item => <a key={item.name} href={item.href} className="text-white/80 hover:text-white font-medium py-2" onClick={() => setIsMobileMenuOpen(false)} data-id="element-68">
                  {item.name}
                </a>)}
              <Button href="/book-call" className="w-full" showArrow data-id="element-69">
                Schedule a Strategy Call
              </Button>
            </div>
          </div>}
      </nav>
    </header>;
}
<meta name="facebook-domain-verification" content="iw4tkcc3d21rlsd9jd9030phzrmgwz" data-id="element-70" />;